import React from "react"
import { RaisedButton } from "material-ui"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import IntegrationConfirmDialog from "./IntegrationConfirmDialog"
import AppStateStore from "../../../../stores/AppStateStore"
import { ITimecardSequenceWarningData } from "../../../../models"
interface IState {
    openConfirmDialogToExport: boolean
}

export default class IntegrationCard extends React.Component<{}, IState> {
    constructor(props) {
        super(props)
        this.state = {
            openConfirmDialogToExport: false
        }
    }

    render() {
        return (
            <div>
                <div style={{ marginBottom: 10 }}>{strings.Exports_any_third_party_punches_that_were_not_successfully_uploaded}</div>
                <RaisedButton
                    data-intercom-target={"menu-AccountSettings-Integration-Btn-ExportToThirdParty"}
                    label={strings.Export_To_Third_Party}
                    primary
                    onClick={() => this.setState({ openConfirmDialogToExport: true })}
                />
                {this.state.openConfirmDialogToExport &&
                    <IntegrationConfirmDialog
                        handleExport={(startDate, endDate) => {
                            this.setState({ openConfirmDialogToExport: false })
                            AppStateStore.setProgressSnackbarContent("loading")
                            api.exportToThirdParty(startDate as string, endDate as string)
                                .then(res => {
                                    const result: ITimecardSequenceWarningData = res.data
                                    result.WarningItems && result.WarningItems.length > 0 ?
                                        AppStateStore.setTimecardSequenceWarningDialogContent({ warningData: result }) :
                                        AppStateStore.setProgressSnackbarContent(strings.Punches_are_set_export_on_next_connector_cycle)
                                })
                                .catch(() => AppStateStore.setProgressSnackbarContent(strings.failed_to_set_export))
                        }}
                        close={() => this.setState({ openConfirmDialogToExport: false })}
                    />
                }
            </div>
        )
    }
}